function combineRoutes<T>(baseRoute: string, subRoutes: T): T {
  return Object.keys(subRoutes as any).reduce(
    (v, k) => ({ ...v, [k]: subRoutes[k] ? `${baseRoute}/${subRoutes[k]}` : baseRoute }),
    {}
  ) as any;
}

const baseRoutes = {
  home: '/',
  competenceDashboard: '/competenceDashboard',
  sidDashboard: '/sidDashboard',
  certificateOverview: '/CertificateOverview',
  applicationsOverview: '/applicationsOverview',
  endorsements: '/endorsements',
  newApplication: '/newapplication',
  newSidApplication: '/newSidApplication',
  applicationBase: '/application/:applicationUid',
  certificate: '/certificate/:certificateUid',
  paymentWindow: `/paymentWindow`,
  profile: `/profile`,
};

const applicationSubRoutes = {
  qualification: 'steps/qualifications',
  addCourse: 'steps/qualifications/:attachmentGroup/addcourse',
  addSeagoing: 'steps/qualifications/:attachmentGroup/addseagoing',
  addSeagoingAttachment: 'steps/qualifications/:attachmentGroup/addseagoingattachment',
  addSeagoingNew: 'steps/qualifications/:requirement/addseagoingnew',
  addAssessment: 'steps/qualifications/:attachmentGroup/addAssessment',
  addAdditionalCompetence: 'steps/qualifications/:attachmentGroup/addAdditionalCompetence',
  addHealthCheck: 'steps/qualifications/:attachmentGroup/addHealthCheck',
  addPhoto: 'steps/qualifications/:attachmentGroup/addPhoto',
  addSignature: 'steps/qualifications/:attachmentGroup/addSignature',
  addCertificate: 'steps/qualifications/:attachmentGroup/addCertificate',
  addConfirmation: 'steps/qualifications/:attachmentGroup/addConfirmation',
  addForeignId: 'steps/qualifications/:attachmentGroup/addForeignId',
  addNorwegianId: 'steps/qualifications/:attachmentGroup/addNorwegianId',
  editCourse: 'steps/qualifications/:attachmentGroup/editcourse',
  editSeagoing: 'steps/qualifications/:attachmentGroup/editseagoing',
  contactInfo: 'steps/contactinfo',
  photoAndSignature: 'steps/photoandsignature',
  summary: 'steps/summary',
  payment: 'steps/payment',
  details: '',
  uploadMissingDocumentation: 'uploadmissingdocumentation',
  missingDocumentation: 'missingdocumentation',
  addFiles: 'addfiles',
};

const externalApplications = {
  paymentproxy: process.env.REACT_APP_API_URL_PAYMENT_WINDOW,
  paymentsolution: process.env.REACT_APP_EXTERNAL_URL_PAYMENT_SOLUTION,
};

export const routes = {
  ...baseRoutes,
  application: combineRoutes(baseRoutes.applicationBase, applicationSubRoutes),
  ...externalApplications,
};
